import { Link } from 'react-router-dom'

export function SiteFooter() {
  return (
    <footer className="bg-gray-900 text-white py-12 mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-4 gap-8">
          <div className="col-span-2">
            <h3 className="text-2xl font-bold mb-4">UMKM Indonesia</h3>
            <p className="text-gray-400 max-w-sm">
              Platform katalog produk digital terbaik untuk UMKM Indonesia.
              Kelola brand, produk, dan tampilkan usaha Anda secara profesional.
            </p>
          </div>
          <div>
            <h4 className="font-semibold mb-4">Produk</h4>
            <ul className="space-y-2 text-gray-400">
              <li><Link to="/brand" className="hover:text-white transition">Brand Management</Link></li>
              <li><Link to="/products" className="hover:text-white transition">Product Catalog</Link></li>
              <li><Link to="/subscription" className="hover:text-white transition">Pricing</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="font-semibold mb-4">Support</h4>
            <ul className="space-y-2 text-gray-400">
              <li><Link to="/catalog" className="hover:text-white transition">Katalog UMKM</Link></li>
              <li><Link to="/artikel" className="hover:text-white transition">Artikel</Link></li>
              <li><Link to="/privacy" className="hover:text-white transition">Kebijakan Privasi</Link></li>
            </ul>
          </div>
        </div>
        <div className="border-t border-gray-800 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-500 text-sm">
            © {new Date().getFullYear()} UMKM Indonesia. All rights reserved.
          </p>
          <div className="flex gap-6 mt-4 md:mt-0">
            <Link to="/privacy" className="text-gray-400 hover:text-white transition text-sm">Privacy</Link>
            <Link to="/promo" className="text-gray-400 hover:text-white transition text-sm">Promo</Link>
          </div>
        </div>
      </div>
    </footer>
  )
}
